/**
 * Cockpit shell — page-tabs horizontal (herda estilo navigation-tab).
 * Spec NEW_RULES 08.UI_UX_UNIFORME.md §Tabs Internas (linhas 526-580).
 * Sidebars estão BANIDOS nas GenApps (Layout Universal 7 camadas sem sidebar).
 */
import { NavLink, Outlet } from 'react-router-dom';
import './Cockpit.css';

const TABS = [
  { to: '/cockpit', label: 'Nova Encomenda', icon: '⌨', end: true },
  { to: '/cockpit/orders', label: 'Encomendas', icon: '📋' },
  { to: '/cockpit/pending', label: 'Pendentes', icon: '⏳' },
  { to: '/cockpit/blocked', label: 'Bloqueadas', icon: '🚫' },
  { to: '/cockpit/reports', label: 'Relatórios', icon: '📊' },
];

const Cockpit = () => (
  <div className="gencrm_cockpit">
    <div className="gencrm_page-tabs">
      {TABS.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          end={t.end}
          className={({ isActive }) =>
            `gencrm_page-tabs__tab ${isActive ? 'gencrm_page-tabs__tab--active' : ''}`
          }
        >
          {t.icon && <span className="gencrm_page-tabs__icon">{t.icon}</span>}
          <span>{t.label}</span>
        </NavLink>
      ))}
    </div>
    <Outlet />
  </div>
);

export default Cockpit;
